"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startupDataLoaded = exports.loadStartupData = exports.STARTUP_DATA_LOADED = exports.LOAD_STARTUP_DATA = void 0;
var LOAD_STARTUP_DATA = exports.LOAD_STARTUP_DATA = 'LOAD_STARTUP_DATA';
var STARTUP_DATA_LOADED = exports.STARTUP_DATA_LOADED = 'STARTUP_DATA_LOADED';
var loadStartupData = exports.loadStartupData = function loadStartupData() {
  return {
    type: LOAD_STARTUP_DATA
  };
};
var startupDataLoaded = exports.startupDataLoaded = function startupDataLoaded() {
  return {
    type: STARTUP_DATA_LOADED
  };
};